import { ChangeDetectionStrategy, Component, ElementRef, Input, OnChanges, Renderer2, ViewChild } from '@angular/core';

import QRCode from 'qrcode';

import { NgxQrcodeElementTypes } from './qrcode.types';
import { DEFAULT_VALUES } from './qrcode.constants';

@Component({
  selector: 'ngx-qrcode',
  template: `<div #qrcElement [class]="cssClass"></div>`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class QrcodeComponent implements OnChanges {

  @Input() elementType = DEFAULT_VALUES.elementType;
  @Input() cssClass = DEFAULT_VALUES.cssClass;
  @Input() alt: string;
  @Input() value = DEFAULT_VALUES.value;
  @Input() version = DEFAULT_VALUES.version;
  @Input() errorCorrectionLevel = DEFAULT_VALUES.errorCorrectionLevel;
  @Input() margin = DEFAULT_VALUES.margin;
  @Input() scale = DEFAULT_VALUES.scale;
  @Input() width = DEFAULT_VALUES.width;
  @Input() colorDark = DEFAULT_VALUES.colorDark;
  @Input() colorLight = DEFAULT_VALUES.colorLight;

  @ViewChild('qrcElement', { static: true }) qrcElement: ElementRef;

  constructor(private renderer: Renderer2) {
  }

  async ngOnChanges() {
    await this.createQRCode();
  }

  async createQRCode() {
    if (!this.value) {
      return;
    }

    let element: Element;
    element = this.renderer.createElement('img');

    const src = await QRCode.toDataURL(this.value,
      {
        version: this.version,
        errorCorrectionLevel: this.errorCorrectionLevel,
        margin: this.margin,
        scale: this.scale,
        width: this.width,
        color: {
          dark: this.colorDark,
          light: this.colorLight
        }
      });

    element.setAttribute('src', src);
    if (this.alt) {
      element.setAttribute('alt', this.alt);
    }
    this.renderElement(element);
  }

  private renderElement(element): void {
    this.removeElementChildren();
    this.renderer.appendChild(this.qrcElement.nativeElement, element);
  }

  private removeElementChildren(): void {
    for (const node of this.qrcElement.nativeElement.childNodes) {
      this.renderer.removeChild(this.qrcElement.nativeElement, node);
    }
  }
}
